/**
 * Get PostHog feature flags for all active experiments
 * Call this during PostHog initialization in _app.tsx to bootstrap experiments
 */

import { getCroWeb169VariantFromCookie } from "./cro-web-169/getCroWeb169Variant";

export const getBootstrapFeatureFlags = (): Record<string, string> => {
  const flags: Record<string, string> = {};

  // CRO-WEB-169 experiment
  const croWeb169Variant = getCroWeb169VariantFromCookie();
  if (croWeb169Variant) {
    flags["cro-web-169"] = croWeb169Variant;
  }

  // Future experiments can be added here
  // const anotherExperimentVariant = getAnotherExperimentVariant();
  // if (anotherExperimentVariant) {
  //   flags["another-experiment"] = anotherExperimentVariant;
  // }

  return flags;
};
